/* ──────────────────────────────────────────────────────────────────────
   ClientsMarquee — horizontal monochrome logo strip
   Renders between Hero and HomeSections. White bg, 30s seamless scroll,
   hover-to-color reveal, edge fade. Spec:
   docs/superpowers/specs/2026-04-27-clients-marquee-design.md
   ────────────────────────────────────────────────────────────────────── */
function ClientsMarquee() {
  const data = window.DZ_HOME.clientsMarquee;

  return (
    <section className="dz-clients-marquee" aria-label={data.sectionAriaLabel}>
      <h2 className="dz-clients-marquee__title">{data.titleLeading} <em>{data.titleAccent}</em></h2>
      <span className="dz-eyebrow dz-clients-marquee__eyebrow">
        {data.eyebrow}
      </span>
      <div className="dz-clients-marquee__viewport">
        {/* Track contains THREE copies of the logo set so the
            seamless loop works on wide viewports.
            Math: animation translates exactly one set's width
            (-33.333%); after the slide, set 2 sits where set 1
            was (visually identical), and sets 2+3 still cover
            the viewport without exposing empty space.

            Why three copies (not two): viewport widths above
            ~1300px exceed one set's width (~1305px on desktop),
            so a 2-copy track at translate(-50%) would expose
            blank space on the trailing edge. Three copies + the
            -33.333% keyframe (in css/home.css @keyframes
            dz-clients-marquee-scroll) keep the strip filled at
            every animation frame on every viewport. */}
        <div className="dz-clients-marquee__track" style={{ '--dz-marquee-duration': Math.round(36 * data.logos.length / 8) + 's' }}>
          {data.logos.map((l, i) => (
            <img
              key={'a' + i}
              src={l.src}
              alt={l.alt}
              className="dz-clients-marquee__logo"
              decoding="async"
            />
          ))}
          {data.logos.map((l, i) => (
            <img
              key={'b' + i}
              src={l.src}
              alt=""
              aria-hidden="true"
              className="dz-clients-marquee__logo"
              decoding="async"
            />
          ))}
          {data.logos.map((l, i) => (
            <img
              key={'c' + i}
              src={l.src}
              alt=""
              aria-hidden="true"
              className="dz-clients-marquee__logo"
              decoding="async"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
